import OaApiService from './OaApiService';

export default class UserService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.getByKeyUrl = '/SecurityREST/user-by-key';
  }

  getLeadActivity(userKey, data, fullResponse) {
    return this.get('/UserREST/lead-activity', data, userKey, fullResponse);
  }

  getAgentsForPrincipal(userKey, data) {
    return this.get('/UserREST/agents-for-principle', data, userKey);
  }

  getAgentStats(userKey, data) {
    return this.get('/UserREST/agent-stats', data, userKey);
  }

  getCompetitiveStats(userKey, data) {
    return this.get('/UserREST/competitive-stats', data, userKey);
  }

  getLeadCohorts(userKey, data) {
    return this.get('/UserREST/lead-cohorts/', data, userKey);
  }
}
